import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const stateRoutes: Routes = [
  {
    path: 'alabama',
    data: {'alabama': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'arizona',
    data: {'arizona': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'arkansas',
    data: {'arkansas': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'california',
    data: {'california': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'colorado',
    data: {'colorado': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'connecticut',
    data: {'connecticut': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'delaware',
    data: {'delaware': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'florida',
    data: {'florida': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'georgia',
    data: {'georgia': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'idaho',
    data: {'idaho': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'illinois',
    data: {'illinois': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'indiana',
    data: {'indiana': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'iowa',
    data: {'iowa': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'kansas',
    data: {'kansas': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'kentucky',
    data: {'kentucky': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'louisiana',
    data: {'louisiana': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'maine',
    data: {'maine': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'maryland',
    data: {'maryland': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'massachusetts',
    data: {'massachusetts': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'michigan',
    data: {'michigan': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'minnesota',
    data: {'minnesota': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'mississippi',
    data: {'mississippi': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'missouri',
    data: {'missouri': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'montana',
    data: {'montana': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'nebraska',
    data: {'nebraska': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'nevada',
    data: {'nevada': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'new_hampshire',
    data: {'new_hampshire': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'new_jersey',
    data: {'new_jersey': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'new_mexico',
    data: {'new_mexico': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'new_york',
    data: {'new_york': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'north_carolina',
    data: {'north_carolina': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'north_dakota',
    data: {'north_dakota': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'ohio',
    data: {'ohio': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'oklahoma',
    data: {'oklahoma': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
{ 
    path: 'oregon',
    data: {'oregon': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'pennsylvania',
    data: {'pennsylvania': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'rhode_island',
    data: {'rhode_island': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'south_carolina',
    data: {'south_carolina': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'south_dakota',
    data: {'south_dakota': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'tennessee',
    data: {'tennessee': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'texas',
    data: {'texas': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'vermont',
    data: {'vermont': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'virginia',
    data: {'virginia': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'washington',
    data: {'washington': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'washington_dc',
    data: {'washington_dc': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'west_virginia',
    data: {'west_virginia': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'wisconsin',
    data: {'wisconsin': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'wyoming',
    data: {'wyoming': true},
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(stateRoutes)],
  exports: [RouterModule]
})
export class StateRouting { }
